// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAeoDITm9akpB7k2mprn0Fcmxc3vKLipEo",
  authDomain: "locker-cea71.firebaseapp.com",
  databaseURL: "https://locker-cea71-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "locker-cea71",
  storageBucket: "locker-cea71.firebasestorage.app",
  messagingSenderId: "599804506334",
  appId: "1:599804506334:web:dfa32a9ffecd0e2eae124f"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const database = getDatabase(app);

// Export the database for use in other files
export { database };
